import {PersonnelService,} from "@/common/api.service";
import {FETCH_EMPLOYMENT_TYPES,} from "./actions";
import {FETCH_EMPLOYMENT_TYPES_END,} from "./mutations";

const getDefaultState = () => {
    return {
        employmentTypeList: [],
    }
};

const state = getDefaultState();

const getters = {
    employmentTypeList(state) {
        return state.employmentTypeList;
    },
};

const actions = {
    [FETCH_EMPLOYMENT_TYPES]({commit}) {
        return PersonnelService.getAllEmploymentTypes()
            .then(({data}) => {
                commit(FETCH_EMPLOYMENT_TYPES_END, data);
            })
            .catch(error => {
                throw new Error(error);
            });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [FETCH_EMPLOYMENT_TYPES_END](state, data) {
        state.employmentTypeList = data;
        state.isLoading = false;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
